import { render, staticRenderFns } from "./SoftSkillsDialog.vue?vue&type=template&id=a5dff19e&"
import script from "./SoftSkillsDialog.vue?vue&type=script&lang=js&"
export * from "./SoftSkillsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports